import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type EyebrowProps = HTMLAttributes<HTMLSpanElement>;

export const Eyebrow = forwardRef<HTMLSpanElement, EyebrowProps>(function Eyebrow(
  { className, children, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={cn("dateline inline-block", className)} {...rest}>
      {children}
    </span>
  );
});
